import {medicineReferences} from "../../hooks/medicineReferences.mjs";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Swiper, SwiperSlide } from "swiper/react";
import { Keyboard, Pagination, Autoplay } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import LoadingBox from "../misc/Loading";
import ProductSmall from "../product/ProductSmall";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useNavigate } from "react-router-dom";
import { useLangPath } from "../../hooks/langAlias";
import { mergeMedicineList } from "../../hooks/mergeMedicineList";
import { colors, fonts, radii } from "../../theme/designTokens";

export default function NewProducts() {
  const navigate = useNavigate();
  const lp = useLangPath();
  // Responsive
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"));
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));
  const xlUp = useMediaQuery(theme.breakpoints.up("xl"));

  // ! ============== Medicine Section
  const [lang, setLang] = useState("en");
  const [medLoading, setMedLoading] = useState(false);
  const [medList, setMedList] = useState([]);
  const [catList, setCatList] = useState([]);

  // store
  const { medicines, categories } = useSelector((state) => state.medicine);
  const { activeLangFront } = useSelector((state) => state.miscFront);

  // Use Effect
  useEffect(() => {
    // if (!(medicines && medicines.length > 0)) dispatch(getMedicines());
    // if (!(categories && categories.length > 0)) dispatch(getMedCategories());
  }, []);

  // Set Medicine
  useEffect(() => {
    setMedLoading(true);
    if (lang !== "" && medicines && medicines.length > 0) {
      const mergedData = mergeMedicineList(medicines, lang);
      if (mergedData.length > 0) {
        let arr = [...mergedData].sort((a, b) =>
          a.genericBrand.toLowerCase() > b.genericBrand.toLowerCase() ? 1 : -1
        );
        arr = arr.filter((m) => m.visible === true);
        arr = arr.filter((a) => a.new === true);
        if (arr) arr = arr.slice(0, 10);
        setMedList([...arr]);
      } else {
        setMedList([]);
      }
    }
    if (medicines) {
      setTimeout(() => {
        setMedLoading(false);
      }, 1000);
    }
  }, [medicines, lang]);

  // set Category
  useEffect(() => {
    if (lang !== "" && categories && categories.length > 0) {
      const C = {data: medicineReferences(categories, lang, "category")};
      if (C) setCatList(C.data);
      else setCatList([]);
    }
  }, [categories, lang]);

  // Set Language
  useEffect(() => {
    if (activeLangFront) {
      setLang(activeLangFront.langCode);
    }
  }, [activeLangFront]);
  // ! ============== Medicine Section

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = "";
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      }
    }
    return translation;
  };
  //! Translate
  return (
    <Box sx={{ py: { xs: 4, md: 6 } }}>
      <Box sx={{ maxWidth: 1600, mx: "auto", px: { xs: 2, sm: 3 } }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 2, mb: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: radii.md,
                bgcolor: colors.primaryLight,
                color: colors.primary,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <AutoAwesomeOutlinedIcon />
            </Box>
            <Box>
              <Typography sx={{ fontFamily: fonts.display, fontWeight: 800, fontSize: "1.4rem", color: colors.ink }}>
                Latest Upload
              </Typography>
              <Typography sx={{ fontSize: 13.5, color: colors.ink3 }}>
                Recently added to our catalogue
              </Typography>
            </Box>
          </Box>
          <Box
            onClick={() => navigate(lp("/our-medicines"))}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.75,
              fontSize: 14,
              fontWeight: 700,
              color: colors.primary,
              cursor: "pointer",
              "&:hover": { color: colors.primaryDark },
            }}
          >
            {translateFront("View All")} <ArrowForwardIcon sx={{ fontSize: 16 }} />
          </Box>
        </Box>

        {medLoading ? (
          <LoadingBox w={"100%"} h={"600px"} />
        ) : (
          <Swiper
            slidesPerView={!smUp ? 1 : !mdUp ? 2 : !xlUp ? 3 : 4}
            grabCursor
            modules={[Keyboard, Pagination, Autoplay]}
            autoplay={{ delay: 5000 }}
            loop={{ loop: true }}
            spaceBetween={20}
            pagination={{ clickable: true }}
            className="deal"
          >
            {medList.map((x, i) => (
              <SwiperSlide key={i}>
                <ProductSmall
                  x={x}
                  i={i}
                  view={0}
                  catList={catList}
                  lang={lang}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </Box>
    </Box>
  );
}
